import { format, parseISO } from "date-fns";

/** The Java services return "yyyy-MM-dd HH:mm:ss"; the Django ones return ISO. */
function toDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const normalised = value.includes("T") ? value : value.replace(" ", "T");
  try {
    const parsed = parseISO(normalised);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  } catch {
    return null;
  }
}

/** The viewer's zone, e.g. "EDT". Shown on any date they might act on. */
export function timeZoneAbbreviation(): string {
  try {
    const parts = new Intl.DateTimeFormat(undefined, { timeZoneName: "short" }).formatToParts(
      new Date(),
    );
    return parts.find((part) => part.type === "timeZoneName")?.value ?? "";
  } catch {
    return "";
  }
}

export function formatDate(value: string | null | undefined): string {
  const date = toDate(value);
  return date ? format(date, "d MMM yyyy") : "";
}

export function formatDateTime(value: string | null | undefined): string {
  const date = toDate(value);
  return date ? format(date, "d MMM yyyy, HH:mm") : "";
}

/** For dates the reader acts on, where an ambiguous zone is a trap. */
export function formatDateTimeWithZone(value: string | null | undefined): string {
  const date = toDate(value);
  if (!date) return "";
  const zone = timeZoneAbbreviation();
  return `${format(date, "d MMM yyyy, HH:mm")}${zone ? ` ${zone}` : ""}`;
}
